module.exports = __webpack_public_path__ + "img/delete.53d0e24c.svg";